import { Injectable } from '@angular/core';

import { CatalogObjectSelection, Layer, ObjectBrowserFilter } from '@mirage-projects/cw-models';

import { TranslationService } from '../translate/translation.service';
import { LayerListFilterService } from './layer-list-filters.service';

/**
 * Service that provides several layer list utility functions
 */
@Injectable({ providedIn: 'root' })
export class LayerListHelperService {
    constructor(
        private translationService: TranslationService,
        private layerFilterService: LayerListFilterService
    ) {}

    /**
     * This function updates the name of the specific layer depending on whether the layer is incomplete
     * @param row layer
     * @returns the name of the layer
     */
    nameFormat(row: CatalogObjectSelection): string {
        const uploading = (row.catalogObject as Layer).incomplete
            ? ` (${this.translationService.translate('LAYERS.UPLOADING_PENDING')})`
            : '';

        return `${row.catalogObject.name}${uploading}`;
    }

    initFilters(): ObjectBrowserFilter[] {
        return this.layerFilterService.initFilters();
    }

    /**
     * This function formats the projectsCount parameter if the layer is part of the demo project
     * @param row layer
     * @returns '-' if layer is part of the demo project, projectsCount otherwise
     */
    formatProjectCount(row: CatalogObjectSelection): string {
        const projectsCount = (row.catalogObject as Layer).projectsCount;

        return projectsCount < 0 ? '-' : `${projectsCount}`;
    }
}
